@if (mobile()) {
  <button (click)="navigateBack()" hlmBtn variant="ghost" size="icon">
    <ng-icon hlm name="lucideArrowLeft" class="text-primary" />
  </button>
} @else {
  <button (click)="navigateBack()" hlmBtn variant="outline">
    <ng-icon hlm name="lucideArrowLeft" />
    @if (!mobile()) {
      <span>Back</span>
    }
  </button>
}
